
export const getStartEndWeek = (date) => {

  let startWeek = new Date(date);
      startWeek.setDate(date.getDate() - date.getDay())
  let endWeek = new Date(startWeek);
      endWeek.setDate(startWeek.getDate() + 6);

  return [startWeek, endWeek];

}
